const BRAZILIAN_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export const parseBrazilianDate = (value: string): Date | null => {
	const match = BRAZILIAN_DATE_PATTERN.exec(value.trim());

	if (!match) return null;

	const [, dayValue, monthValue, yearValue] = match;
	const day = Number(dayValue);
	const month = Number(monthValue);
	const year = Number(yearValue);
	const date = new Date(Date.UTC(year, month - 1, day));

	if (
		date.getUTCFullYear() !== year ||
		date.getUTCMonth() !== month - 1 ||
		date.getUTCDate() !== day
	) {
		return null;
	}

	return date;
};

export const toBrazilianDateIso = (value: string): string | undefined => {
	const date = parseBrazilianDate(value);

	if (!date) return undefined;

	return `${date.toISOString().slice(0, 10)}T12:00:00-03:00`;
};
